import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=5c283d93&scoped=true&"
import script from "./openApp.vue?vue&type=script&lang=ts&"
export * from "./openApp.vue?vue&type=script&lang=ts&"
import style0 from "./openApp.vue?vue&type=style&index=0&id=5c283d93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c283d93",
  null
  
)

export default component.exports